// الأسئلة الشائعة

import { useState } from "react";

const faqs = [
  {
    question: "ما أنواع المواد التي يتم إعادة تدويرها؟",
    answer:
      "نستقبل مجموعة متنوعة من المواد القابلة لإعادة التدوير، ويتم التعامل مع كل نوع وفق آلية مناسبة لضمان الاستفادة منه بالشكل الأمثل.",
  },
  {
    question: "كيف يمكنني طلب خدمة الاستلام؟",
    answer:
      "يمكنك التواصل معنا من خلال نموذج التواصل أو وسائل الاتصال المتاحة في الموقع، وتزويدنا بنوع المواد والموقع والموعد المناسب.",
  },
  {
    question: "هل توفرون خدمة الاستلام من الموقع؟",
    answer:
      "نعم، نوفر خدمة استلام المواد من المواقع المحددة وفق نطاق الخدمة والموعد المتفق عليه.",
  },
  {
    question: "كيف يتم تحديد موعد الاستلام؟",
    answer:
      "بعد إرسال الطلب والتواصل مع فريقنا، يتم التنسيق معك لتحديد الموعد المناسب حسب الموقع ونوع وكمية المواد.",
  },
  {
    question: "ماذا يحدث للمواد بعد استلامها؟",
    answer:
      "تمر المواد بعد الاستلام بمرحلة الفرز والتجهيز، ثم يتم توجيهها إلى عمليات إعادة التدوير المناسبة حسب نوع المادة.",
  },
  {
    question: "هل يمكن للشركات والمنشآت الاستفادة من خدماتكم؟",
    answer:
      "نعم، نقدم حلولًا مناسبة للشركات والمنشآت التي لديها كميات أو احتياجات مستمرة من المواد القابلة لإعادة التدوير.",
  },
];
export default function FAQPreview() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="bg-white py-20 md:py-24 lg:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <span className="mb-3 inline-block text-sm font-semibold text-green-600">
            الأسئلة الشائعة
          </span>

          <h2 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
            كل ما تريد معرفته
          </h2>

          <p className="mt-5 leading-8 text-gray-600">
            تعرف على أبرز الأسئلة المتعلقة بخدماتنا وآلية العمل.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className={`overflow-hidden rounded-xl border transition-all duration-300 ${
                  isOpen
                    ? "border-green-200 bg-green-50/40"
                    : "border-gray-200 bg-white"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-6 px-5 py-5 text-right md:px-6"
                >
                  <span className="font-semibold leading-7 text-gray-900">
                    {faq.question}
                  </span>

                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                      isOpen
                        ? "rotate-180 bg-green-600 text-white"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="h-4 w-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m6 9 6 6 6-6"
                      />
                    </svg>
                  </span>
                </button>

                <div
                  className={`grid transition-all duration-300 ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-green-100 px-5 pb-5 pt-4 text-sm leading-8 text-gray-600 md:px-6">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
